export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "grandslotbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "grandslotbet-themeWrap" */'./ThemeImporter'),
  },
};
